import styles from "../Merging.module.css";
import React, {useEffect, useState, forwardRef, useImperativeHandle} from "react";
import TextAreaWithTabs from "../../UI/TextAreaWithTabs/TextAreaWithTabs";


const SimpleMergeTextFields = forwardRef (({toPattern, fromPattern, rows = 5, title}, ref) => {
    const [toText, setToText] = useState('')
    const [fromText, setFromText] = useState('')

    useImperativeHandle(ref, () => ({
        getText: () => {
            return String(toText);
        }
    }));

    useEffect(() => {
        setToText(toPattern || '')
    }, [toPattern]);

    useEffect(() => {
        setFromText(fromPattern || '')
    }, [fromPattern]);


    return <div className={styles.Container}>
        <div className={styles.SplitCols}>
            <h3>{title}</h3>
            <TextAreaWithTabs value={toText || ''} rows={rows} onChange={(e) => setToText(e.target.value)}/>
        </div>
        <div className={styles.Separator}></div>
        <div className={styles.SplitCols}>
            <h3>{title}</h3>
            <TextAreaWithTabs value={fromText || ''} rows={rows} onChange={() => {}}/>
        </div>
    </div>
});

export default SimpleMergeTextFields